import React from 'react';
import { Link } from 'react-router-dom';
import MediaFrame from '../shared/MediaFrame';
import { destinationFallbackSrc } from '../../data/nepalImages';
import '../../styles/media.scss';

const CATEGORY_LABELS = {
	national_park: 'National Park',
	unesco_site: 'UNESCO Site',
	lake: 'Lake',
	waterfall: 'Waterfall',
	temple: 'Temple',
	monastery: 'Monastery',
	museum: 'Museum',
	viewpoint: 'Trek / Viewpoint',
	other: 'Destination'
};

const DestinationCard = ({ destination }) => {
	const { name, slug, category, summary, hero_image_url: heroImage, difficulty, district } = destination;
	const imageSrc = heroImage || destinationFallbackSrc(slug);

	return (
		<Link to={`/destinations/${slug}`} className="destination-card">
			<MediaFrame src={imageSrc} category={category} seed={slug} alt={name} variant="thumb" className="destination-card__image">
				<span className="destination-card__category">{CATEGORY_LABELS[category] || category}</span>
			</MediaFrame>
			<div className="destination-card__body">
				<h3 className="destination-card__title">{name}</h3>
				{district && <p className="destination-card__district"><i className="fas fa-map-marker-alt" aria-hidden="true" /> {district.name}</p>}
				{summary && <p className="destination-card__summary">{summary}</p>}
				{difficulty && <span className={`destination-card__difficulty destination-card__difficulty--${difficulty}`}>{difficulty}</span>}
			</div>
		</Link>
	);
};

export default DestinationCard;
